import { Insight } from "react-migration/components/Insight/Insight";
import { Loading } from "react-migration/components/Loading";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { CurrencyCode } from "react-migration/lib/typings/Currency";
import { formatToCurrency } from "react-migration/lib/util/numberFormat";
import { userStore, MeasurementSystem } from "src/js/stores/user/store";
import { useSnapshot } from "valtio";

export function PriceSquare({
  title,
  price,
  area,
  loading,
}: {
  title: string;
  price: number;
  area: number;
  loading: boolean;
}) {
  const { unit } = useSnapshot(userStore.user.settings);
  const { t } = useTranslation();

  return (
    <Insight.Wrapper
      title={
        <div className="flex items-center gap-x-1">
          <div className="w-3 h-3 rounded-full bg-platform-blue-800" />
          {title}
        </div>
      }
    >
      <Insight.Body>
        {loading ? (
          <div className="p-4">
            <Loading />
          </div>
        ) : price ? (
          formatToCurrency({ amount: price, currency: CurrencyCode.GBP, maximumFractionDigits: 0 })
        ) : (
          "-"
        )}
      </Insight.Body>
      {area ? (
        <Insight.Footer>
          {formatToCurrency({ amount: area, currency: CurrencyCode.GBP, maximumFractionDigits: 0 })}/
          {unit === MeasurementSystem.METRIC ? t("comparables.sqm.alt") : t("comparables.sqft.alt")}
        </Insight.Footer>
      ) : null}
    </Insight.Wrapper>
  );
}
